import React, { useCallback, useEffect, useRef, useState } from "react";

import { addVerificationComment, getAllAdminUsers, getVerificationComments } from "services";

import { formatDayDate, getAdminVerificationYearlyDataYear, useAdminUserContext, useCancelAsyncOnUnmount } from "utils";

import { Avatar, Card, Col, CommentInputPanel, Row, Typography } from "components";

export const VerificationComments = ({ verificationFieldId, farmId, type, setCommentCount, onCommentCreate }) => {
  const [loading, setLoading] = useState(false);
  const [comments, setComments] = useState([]);
  const signal = useCancelAsyncOnUnmount()();
  const [adminUsers, setAdminUsers] = useState([]);
  const year = getAdminVerificationYearlyDataYear();
  const { user } = useAdminUserContext();
  const formRef = useRef(null);

  const loadAdminUsers = useCallback(() => {
    getAllAdminUsers({
      signal,
    }).then((res) => {
      setAdminUsers(res);
    });
  }, [signal]);

  const loadComments = useCallback(() => {
    let id;

    switch (type) {
      case "farm":
        id = farmId;
        break;
      case "field":
        id = verificationFieldId;
        break;
      default:
        break;
    }
    getVerificationComments({
      id: id,
      type,
      signal,
    }).then((res) => {
      setComments(res ?? []);
      setCommentCount(res?.length ?? 0);
    });
  }, [type, signal, verificationFieldId, farmId, setCommentCount]);

  const complete = (v) => {
    setLoading(true);
    addVerificationComment({
      ...v,
      type,
      farmId,
      year,
      verificationFieldId,
      adminId: user.id,
      signal,
    }).then(() => {
      loadComments();
      onCommentCreate?.();
      setLoading(false);
      formRef.current.setFieldsValue({ content: "" });
    });
  };

  const incomplete = () => {
    // message({ content: "fill in the comment input", icon: "error" });
  };

  useEffect(() => {
    loadComments();
    loadAdminUsers();
  }, [loadAdminUsers, loadComments]);
  return (
    <>
      {adminUsers.length > 0 && (
        <>
          {!comments || comments.length === 0 ? (
            <Typography variant="paragraph-m" color="grey-600">
              {" "}
              no comments have been added.
            </Typography>
          ) : (
            <>
              {comments.map((answer, i) => {
                const isPoster = answer.adminId !== user.id;
                const posterName = adminUsers.find((admin) => admin.id === answer.adminId).name;
                return (
                  <Row key={i}>
                    <Col>
                      <Card className={`${isPoster ? "is-poster" : ""}`}>
                        {isPoster && (
                          <div className="image">
                            <Avatar name={posterName} />
                          </div>
                        )}
                        <>
                          <div className="content">
                            {isPoster ? (
                              <div className="headline">
                                <Typography variant="h5" className="name">
                                  {posterName}
                                </Typography>
                              </div>
                            ) : (
                              <div style={{ width: "100%" }}>
                                <div className="headline">
                                  <Typography variant="h5" className="name">
                                    {posterName}
                                  </Typography>
                                </div>
                              </div>
                            )}
                            <div className="answer">{answer.content}</div>
                            <div className="extra">
                              <Typography variant="paragraph-m" className="date">
                                {formatDayDate(answer?.createdAt)}
                              </Typography>
                            </div>
                          </div>
                          {!isPoster && (
                            <div className="image">
                              <Avatar name={posterName} />
                            </div>
                          )}
                        </>
                      </Card>
                    </Col>
                  </Row>
                );
              })}
            </>
          )}
          <Row className="margin-top-200">
            <Col>
              <CommentInputPanel
                buttonText={"Send comment"}
                formRef={formRef}
                label={"comment"}
                name="content"
                onFinish={(v) => complete(v)}
                onFinishFailed={(v) => incomplete(v)}
                userName={`${user.firstName} ${user.lastName}`}
                loading={loading}
                required={false}
              />
            </Col>
          </Row>
        </>
      )}
    </>
  );
};
